import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-emerald-50">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Button variant="outline" onClick={() => navigate('/')} className="mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Ana Sayfaya Dön
        </Button>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-slate-800 mb-6">Gizlilik Politikası</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-lg text-slate-600 mb-6">
              <strong>Son Güncelleme:</strong> {new Date().toLocaleDateString('tr-TR')}
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">1. Toplanan Bilgiler</h2>
            <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
              <li>Hesap oluşturma: Ad, e-posta, şifre</li>
              <li>Değerlendirme: Mizaç testi cevapları</li>
              <li>Kullanım: Platform etkileşimleri, oturum bilgileri</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">2. Bilgilerin Kullanımı</h2>
            <p className="text-slate-700 mb-4">
              Bilgileriniz yalnızca hizmet sunumu, kişiselleştirme ve platform iyileştirme için kullanılır.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">3. Veri Güvenliği</h2>
            <p className="text-slate-700 mb-4">
              Tüm veriler şifreli olarak saklanır. Endüstri standartlarında güvenlik önlemleri uygulanır.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">4. Üçüncü Taraf Paylaşımı</h2>
            <p className="text-slate-700 mb-4">
              Kişisel bilgileriniz, yasal zorunluluklar dışında üçüncü taraflarla paylaşılmaz.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}